export function formatSentence(str: string) {
  return str
    .split(/\s+/)
    .map((word, index) => {
      // 单词中是否存在小写字母
      const hasLower = /[a-z]/.test(word);

      if (!hasLower) {
        // 全大写或全非字母，保持不变
        return word;
      }

      // 有小写 → 转为小写
      const lower = word.toLowerCase();

      // 第一个单词首字母大写（除非本身是全大写词）
      if (index === 0) {
        return lower.charAt(0).toUpperCase() + lower.slice(1);
      }

      return lower;
    })
    .join(' ');
}

const UID_ALPHABET = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_';

export function createUid(prefix?: string, length = 21) {
  if (!Number.isInteger(length) || length <= 0) {
    throw new Error('UID length must be a positive integer');
  }

  const cryptoImpl = globalThis.crypto;
  if (!cryptoImpl?.getRandomValues) {
    throw new Error('crypto.getRandomValues is not available');
  }

  const bytes = new Uint8Array(length);
  cryptoImpl.getRandomValues(bytes);

  const uid = Array.from(bytes, (byte) => UID_ALPHABET[byte & 63]).join('');
  return prefix ? `${prefix}_${uid}` : uid;
}
